import { useState } from 'react';
import { Card, CardActionArea, Box, Link, Grid } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import PropTypes from 'prop-types';
import Text from './Text';
import TextEllipsize from 'utils/TextEllipsize';
import { allowSecondClick } from 'utils/utils';
import { style } from 'constant/constants';

const getColor = (imgData) => {
  if (imgData) {
    if (imgData['1stRecommended']) return style.recommended1;
    else if (imgData['2ndRecommended']) return style.recommended2;
  }
  return 'white';
};

const ImageCard = ({ imgData, onClick = null }) => {
  const [lastClickTime, setLastClickTime] = useState(0);

  const text = (
    <Text
      sx={{
        m: 0,
        color: '#0000FF',
        fontSize: 14,
        fontWeight: 'bold'
      }}
      gutterBottom
      lineHeight={0.8}
      variant="body1">
      <TextEllipsize value={imgData?.title} maxChars={30} />
    </Text>
  );

  const materials =
    imgData?.materials?.length > 0
      ? imgData?.materials?.map((material) => (
          <Text
            key={material.id}
            sx={{
              m: 0,
              mt: 1.5,
              color: '#0000FF',
              display: 'block',
              width: '60%',
              fontSize: 12,
              cursor: 'pointer',
              '&:hover': { fontSize: 14 }
            }}
            gutterBottom
            lineHeight={0.8}
            onClick={
              onClick &&
              (() => {
                !allowSecondClick(lastClickTime, setLastClickTime) && onClick(material?.material);
              })
            }
            variant="body1">
            <span style={{ lineHeight: '13px' }}>{material?.material}</span>:{' '}
            <span style={{ lineHeight: '13px' }}>{material?.price} $</span>
          </Text>
        ))
      : null;

  const html = (
    <Grid item xs={4} sx={{ alignContent: 'flex-start', mb: 1 }}>
      <Card
        sx={{
          m: 1,
          mr: 0,
          maxWidth: '100%',
          height: imgData.materials?.length > 0 ? '100%' : 'auto',
          backgroundColor: 'white',
          border: getColor(imgData) !== 'white' ? 1 : 0
        }}>
        <CardActionArea
          onClick={
            onClick &&
            (() => {
              !allowSecondClick(lastClickTime, setLastClickTime) && onClick();
            })
          }>
          <Box sx={{ height: 130, overflow: 'hidden' }}>
            <CardMedia
              component="img"
              image={imgData?.url}
              alt={imgData?.altText}
              sx={{
                height: 130,
                objectFit: 'fill'
              }}
            />
          </Box>
        </CardActionArea>
        <CardContent
          sx={{
            p: 1,
            alignVertical: 'center',
            backgroundColor: getColor(imgData),
            height: '100%'
          }}>
          {imgData?.link ? (
            <Grid display="flex">
              <Link
                href={imgData?.link}
                display="flex"
                underline="hover"
                target="_blank"
                rel="noopener noreferrer">
                {text}
              </Link>
            </Grid>
          ) : (
            text
          )}
          {imgData['2ndRecommended'] ? (
            <TextEllipsize value="2nd Recomendation" />
          ) : imgData['1stRecommended'] ? (
            <TextEllipsize value="1st Recomendation" />
          ) : (
            ''
          )}
          {materials}
        </CardContent>
      </Card>
    </Grid>
  );

  return imgData.materials?.length > 0 ? materials && html : html;
};

ImageCard.propTypes = {
  imgData: PropTypes.object,
  onClick: PropTypes.func
};

export default ImageCard;
